export default __webpack_public_path__ + "static/media/title.b860d6ae.svg";